import { errorAction } from '@shared/actions';
import { ADD_LINE } from '@core/reducers/cart/actionTypes';
import addLine from './addLine';

const type = ADD_LINE;
const errorMessage =
  'Ocurrió un error al agregar algunos de tus productos. Por favor intente nuevamente.';

const addCartItems = ({ lines, origin }) => async dispatch => {
  try {
    lines.forEach(line => {
      addLine({
        line,
        origin,
      });
    });
  } catch (error) {
    dispatch(errorAction({ type, error, errorMessage }));
  }
};

export default addCartItems;
